import styled from "styled-components";
import {IThemeProvider} from "../../../../../Theme/defaultTheme";

export const StyledCampaignForm = styled.div<IThemeProvider>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.format.main_md_gap};
`;